export default class AdminService {
  constructor(axios) {
    this.axios = axios
  }

  async users() {
    const { data: { data } } = await this.axios.get('admin/users/list-all')
    return data
  }

  /**
   * @param {object} ctx
   * @param {string} ctx.firstName
   * @param {string} ctx.lastName
   * @param {string} ctx.email
   * @param {string} ctx.username
   * @param {string} ctx.password
   */
  async createUser(ctx) {
    const { data: { data } } = await this.axios.post('admin/users/create', ctx)
    return data
  }

  /**
   * @param {string} id
   * @param {object} ctx
   * @param {string=} ctx.firstName
   * @param {string=} ctx.lastName
   * @param {string=} ctx.email
   * @param {string=} ctx.username
   * @param {string=} ctx.password
   */
  async updateUser(id, ctx) {
    const { data: { data } } = await this.axios.put(`admin/users/${id}/update`, ctx)
    return data
  }

  /**
   * @param {string} id
   */
  async disableUser(id) {
    const { data: { data } } = await this.axios.put(`admin/users/${id}/disable`)
    return data
  }

  /**
   * @param {string} id
   */
  async enableUser(id) {
    const { data: { data } } = await this.axios.put(`admin/users/${id}/enable`)
    return data
  }

  /**
   * @param {object} ctx
   * @param {string} ctx.name
   * @param {string} ctx.description
   * @param {string} ctx.path
   */
  async createModule(ctx) {
    const { data: { data } } = await this.axios.post('admin/modules/create', ctx)
    return data
  }

  /**
   * @typedef {Object} AssignRole
   * @property {number} idUser
   * @property {number} idRole
   */
  /**
   * @param {AssignRole[]} roles
   */
  async assignRole(roles) {
    const { data: { data } } = await this.axios.put('admin/roles/assign', { roles })
    return data
  }

  /**
   * @typedef {Object} AssignModule
   * @property {number} idUser
   * @property {number} idModule
   */
  /**
   * @param {AssignModule[]} modules
   */
  async assignModule(modules) {
    const { data: { data } } = await this.axios.put('admin/modules/assign', { modules })
    return data
  }
}
